import { Alert, AlertIcon, Button, Code, Flex, Heading, Stack, Text, useToast } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../components/common/basic/back-button';
import MainLayout from '../../components/common/main-layout';
import LoadingPage from '../loading';
import {
	SERVICE_CAMPAIGN_VOUCHERS_KEY,
	useFetchCampaignByWorkOrder,
	useGenerateCampaignVoucherMutation,
} from '../../state/server-side/queries/carolive-v3';
import { useQueryClient } from 'react-query';

export const CampaniiPromoPage = () => {
	const navigate = useNavigate();
	const { orderId } = useParams();
	const { data, isLoading, isError } = useFetchCampaignByWorkOrder(orderId);

	if (isLoading) {
		return <LoadingPage offset={64} />;
	}

	if (isError) {
		return <div>error</div>;
	}

	const handleBack = () => {
		navigate(`/${orderId}`);
	};

	return (
		<MainLayout alignItems={'start'}>
			<Flex flexDirection={'column'} gap={6} minW={'sm'} maxW={'2xl'}>
				<Heading textAlign={'center'}>Campanii promotionale</Heading>
				{/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
				<InfoCampanie data={data} orderId={orderId} />
				<BackButton onClick={handleBack}>Inapoi la pagina principala</BackButton>
			</Flex>
		</MainLayout>
	);
};

function InfoCampanie({ data, orderId }) {
	const toast = useToast();
	const queryClient = useQueryClient();
	const mutation = useGenerateCampaignVoucherMutation();

	const handleGenerateVoucher = () => {
		mutation.mutate(
			{ workOrderId: orderId },
			{
				onSuccess: () => {
					queryClient.invalidateQueries([SERVICE_CAMPAIGN_VOUCHERS_KEY, orderId]);
				},
				onError: error => {
					if (error?.cause?.message === 'Nu mai sunt vouchere disponibile pentru aceasta campanie.') {
						toast({
							title: 'Eroare!',
							description: error.cause.message,
							status: 'error',
							duration: 5000,
							isClosable: true,
						});
					} else {
						toast({
							description: 'A aparut o eroare.',
							status: 'error',
							duration: 5000,
							isClosable: true,
						});

						queryClient.invalidateQueries([SERVICE_CAMPAIGN_VOUCHERS_KEY, orderId]);
					}
				},
			}
		);
	};

	if (!data) {
		return (
			<Alert status="error">
				<AlertIcon />
				Nu s-a gasit campania promotionala
			</Alert>
		);
	}

	if (data.error === 'VOUCHER_ALREADY_APPLIED') {
		return (
			<Alert status="success">
				<AlertIcon />
				Ai aplicat cu succes un voucher pe acest deviz!
			</Alert>
		);
	}

	if (data.error) {
		if (!data.cashback) {
			return (
				<Alert status="error">
					<AlertIcon />
					{data.error}
				</Alert>
			);
		}

		if (data.cashback && !data.delegat) {
			return (
				<>
					<Alert status="error">
						<AlertIcon />
						{data.error}
					</Alert>
					<Stack fontSize={'lg'}>
						<Text>
							Clientul se incadreaza in campania <Code>{data.cashback.campaignName}</Code>.
						</Text>
						<Text>
							Corecteaza eroarea de mai sus pentru a-i oferi un voucher de{' '}
							<strong>{data.cashback.cashbackAmount} RON</strong>.
						</Text>
					</Stack>
				</>
			);
		}

		return (
			<>
				<Alert status="error">
					<AlertIcon />
					{data.error}
				</Alert>
				<Stack>
					<Text>
						Nume: <strong>{data.delegat.name}</strong>
					</Text>
					<Text>
						Email: <strong>{data.delegat.email}</strong>
					</Text>
				</Stack>
				<Stack fontSize={'lg'}>
					<Text>
						Clientul se incadreaza in campania <Code>{data.cashback.campaignName}</Code>.
					</Text>
					<Text>
						Corecteaza eroarea de mai sus pentru a-i oferi un voucher de{' '}
						<strong>{data.cashback.cashbackAmount} RON</strong>.
					</Text>
				</Stack>
			</>
		);
	}

	return (
		<>
			<Stack>
				<Text>
					Nume:{' '}
					<Text as="span" fontWeight={'bold'} color={'green.400'}>
						{data.delegat.name}
					</Text>
				</Text>
				<Text>
					Email:{' '}
					<Text as="span" fontWeight={'bold'} color={'green.400'}>
						{data.delegat.email}
					</Text>
				</Text>
			</Stack>
			<Text>
				Clientul se incadreaza in campania <Code>{data.cashback.campaignName}</Code> si este eligibil pentru un
				voucher de <strong>{data.cashback.cashbackAmount} RON</strong>.
			</Text>
			<Text fontSize={'lg'} color={'red.400'}>
				⚠️ Confirma adresa de email cu clientul inainte de a genera voucherul!
			</Text>
			<Button colorScheme="green" onClick={handleGenerateVoucher} isLoading={mutation.isLoading}>
				Genereaza voucher
			</Button>
		</>
	);
}
